<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container">
      <div class="row p-0">
        <div class="col p-0 text-center">
            <h5 class="fw-bold d-inline-block bi-person-circle">&nbsp; Profile</h5>
          </div>
          <div class="col-auto p-0 text-center">
            <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadProfile()" :disabled="loading">&nbsp; Reload</button>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="row p-0">
          <div class="col p-0">
            <hr>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="row p-0">
          <div class="col p-0">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="name">
            </div>
          </div>
          <div class="col p-0 text-end">
            <a class="btn btn-success bi-floppy-fill w-50" @click="saveProfile()">&nbsp; Save</a>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="row p-0">
          <div class="col p-0">
            <hr>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="row p-0">
          <div class="col p-0">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Current Password</span>
              <input class="form-control" type="password" v-model.trim="curr_password">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">New Password</span>
              <input class="form-control" type="password" v-model.trim="password">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Confirm Password</span>
              <input class="form-control" type="password" v-model.trim="password2">
            </div>
          </div>
          <div class="col p-0 text-end">
            <a class="btn btn-warning bi-floppy-fill w-50" @click="savePassword()">&nbsp; Save Password</a>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
    </div>
    <!-- =========================================================================================================== -->
  </div>
</template>
<!-- ******************************************************** -->
<script>
  export default {
    name: 'ProfilePage',
    data(){
      return {
        loading: false,
        name: '',
        curr_password: '',
        password: '',
        password2: '',
      }
    },
    async created(){
      this.name = this.$store.state.name;
    },
    methods:{
      async loadProfile(){
        this.loading = true;
        var ack = await this.$service.getProfile();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.name = ack.data.name;
        }
        this.loading = false;
      },
      //-----------------------------------------------
      async saveProfile(){
        this.loading = true;
        var ack = await this.$service.saveProfile({
          name: this.name,
          username: this.username
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Profile Saved', 'success');
          this.$store.dispatch('userName', {name: this.name});
          await this.loadProfile();
        }
        this.loading = false;
      },
      //-----------------------------------------------
      async savePassword(){
        if(!this.curr_password || !this.password || !this.password2){
          return this.$toast('some fields are empty');
        }
        if(this.password != this.password2){
          return this.$toast('passwords does not match');
        }
        this.loading = true;
        var ack = await this.$service.savePass({
          curr_password: this.curr_password,
          new_password: this.password
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Password Saved', 'success');
          this.curr_password = '';
          this.password = '';
          this.password2 = '';
        }
        this.loading = false;
      },
      //-----------------------------------------------
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  